module.exports = __webpack_public_path__ + "assets/login-v2.ae36c5ed.svg";